module.exports = __webpack_public_path__ + "recipe.png?07f1f645e430bd26b9d01d4a369850b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/recipe.png
// module id = 26
// module chunks = 0